/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Redirection, SSOProps } from '@types';
import { isLoading } from '@store/loading';
import { inProgressCustomer, selectRedirection } from '@store/selectors/widgets.selectors';
import { useDispatch, useSelector } from 'react-redux';
import { CodingConstants } from '@constants';
import { useUserDetails } from '@hooks/userDetails';
import { DataContext } from '@context';
import LoadingBar from '@components/LoadingBar/LoadingBar';
import MainContainer from './MainContainer';
import ErrorContainer from './Error.Container';
import IdleTimerContainer from '@components/IdleTimerContainer/IdleTimerContainer';
import { selectError, setSSOError } from '@store/errors';
import { auth, config } from '../config';
import { clearCookie } from '@utils/cookieHelper';
import { getAccountConnectToken } from '@services/AccountConnectFormService';
import { ssoAction } from '@store/actions/sso.action';
import AccConnectFormSubmit from '@components/AccountConnectFormSubmit/AccConnectFormSubmit';
import { useQuery } from '@hooks/useQuery';
import { selectWidgetsError } from '@store/errors/selectors';
import FullScreenModal from '@components/FullScreenModal/FullScreenModal';
import { accessTokenObj } from '@utils/auth.config';
import { setAdditionalProperties } from 'fmc-digital-common';
import { selectEsignPopUpState, selectParent } from '@store/selectors/lip.selector';
import { fetchConfig } from '@store/actions/config.actions';
import { useLocation } from 'react-router-dom';

const Home: React.FunctionComponent = () => {
    const dispatch = useDispatch();

    const [ssoError, setSsoError] = useState(false);
    const query = useQuery();
    const routeName = query.get('route');
    const parent = useSelector(selectParent);

    const esignPopUpState: string = useSelector(selectEsignPopUpState);
    const [ssoData, setSsoData] = useState<SSOProps>({
        url: '',
        token: ''
    });

    const updateSsoData = ({ url, token }: { url: string; token: string }) => {
        setSsoData({
            url,
            token
        });
    };
    const accountDetailSSO = async (url: string) => {
        dispatch(ssoAction());
        const { response, error } = await getAccountConnectToken(`${config.env('ssoUrl')}`, `${config.env('xApiKey')}`);

        if (response) {
            auth.getOkta().tokenManager.clear();
            clearCookie();
            updateSsoData({ url, token: response?.signinToken });
        } else if (error) {
            setSsoError(true);
            dispatch(setSSOError(error));
        }
    };

    const [userInfo] = useUserDetails();
    const loading: boolean = useSelector(isLoading);
    const redirection: Redirection = useSelector(selectRedirection);
    const isLoanAvailable = useSelector(inProgressCustomer);
    const errors = useSelector(selectError);
    const widgetApiError = useSelector(selectWidgetsError);
    const routeUrl: string = useLocation()?.pathname;
    const [displayPage, setDisplayPage] = useState('DashBoard');

    useEffect(() => {
        if (routeUrl.toLowerCase().includes('/mc/')) {
            setDisplayPage('messageCenter');
        }
    }, [routeUrl]);
    useEffect(() => {
        switch (redirection?.appName) {
            case CodingConstants.accountConnect: {
                accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost`);
                break;
            }
            case CodingConstants.myFreedomPortal: {
                auth.getOkta().tokenManager.clear();
                clearCookie();
                window.location.replace(redirection.url);
                break;
            }
            default:
                break;
        }
    }, [redirection]);

    useEffect(() => {
        switch (routeName) {
            case 'manage_account_sso_url':
                accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost`);
                break;
            case 'account_details_sso_url':
                accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost`);
                break;
            case 'pay_now_sso_url':
                accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost?target_menu=oneTimePayment`);
                break;
            case 'recurring_payment_sso_url':
                accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost?target_menu=recurringPayments`);
                break;
            case 'payment_history_sso_url':
                accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost?target_menu=paymentHistory`);
                break;
            case 'all_documents_sso_url':
                accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost?target_menu=statements`);
                break;
            default:
                dispatch(fetchConfig.request());
                break;
        }
    }, [routeName]);
    if (esignPopUpState === 'opened' || (parent && parent.showModal)) return <FullScreenModal {...parent} />;
    return (
        <>
            {loading ? (
                <LoadingBar />
            ) : (
                <>
                    {ssoError ? (
                        <ErrorContainer userName={userInfo.given_name} isUnAuthUser={false} />
                    ) : (
                        /*eslint-disable-next-line @typescript-eslint/ban-ts-comment*/
                        /*@ts-ignore*/
                        <DataContext.Provider value={{ ssoData, updateSsoData, accountDetailSSO }}>
                            {!widgetApiError &&
                                userInfo &&
                                (redirection?.appName === CodingConstants.customerPortal ||
                                    redirection?.appName === CodingConstants.customerPortal2) && (
                                    <>
                                        <MainContainer userName={userInfo.name} displayPage={displayPage} />
                                        <IdleTimerContainer />
                                    </>
                                )}
                            {!isLoanAvailable &&
                                userInfo &&
                                errors &&
                                errors.length > 0 &&
                                !ssoError &&
                                accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost`)}
                        </DataContext.Provider>
                    )}
                </>
            )}
            {(redirection || (ssoData.url !== '' && ssoData.token !== '')) && (
                <AccConnectFormSubmit method="post" action={ssoData.url} value={ssoData.token} />
            )}
        </>
    );
};

export default Home;
